import React from 'react';

const IconKamus = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5C4 3.34315 5.34315 2 7 2H19C19.5523 2 20 2.44772 20 3V16V19C20 19.5523 19.5523 20 19 20H10V22L9 21.5556L8 22V20H6.5H6C4.89543 20 4 19.1046 4 18V17.5V5ZM8 18H10H18V17H6.5C6.22386 17 6 17.2239 6 17.5C6 17.7761 6.22386 18 6.5 18H8ZM18 4V15H9V4H18ZM6.5 15H7V4C6.44772 4 6 4.44772 6 5V15.05C6.16156 15.0172 6.32877 15 6.5 15ZM12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9H15C15.5523 9 16 8.55228 16 8C16 7.44772 15.5523 7 15 7H12Z"
        fill="#06090D"
      />
    </svg>
  );
};

export default IconKamus;
